export const USER_ACTION_IDS = {
  ACTION_UNDEFINED: 0,
  ACTION_ADD_BREW_WATER: 1,
  ACTION_PREPARE_CLEANING: 2,
  ACTION_CHECK_ACTIVITY_STARTED: 3,
  ACTION_ADD_INGREDIENT: 4,
  ACTION_REMOVE_INGREDIENT: 5,
  ACTION_CONNECT_WATER: 6,
  ACTION_PLACE_KEG: 7,
  ACTION_REMOVE_TRUB: 8,
  ACTION_CHECK_ACTIVITY_STOPPED: 9,
  ACTION_MOUNT_TAP: 10,
  ACTION_REMOVE_KEG: 11,
  ACTION_NEEDS_CLEANING: 12,
  ACTION_CHECK_ERROR: 13,
  ACTION_PLACE_CLEANING_ACCESSORIES: 14,
  ACTION_PREPARE_RINSING: 15,
  ACTION_ADD_RINSE_WATER: 16,
  ACTION_CLEAN_BALLVALVE: 17,
  ACTION_EMPTY_KEG: 18,
  ACTION_FILL_MASH_TUN: 19,
  ACTION_FILL_CAROUSEL: 20,
  ACTION_START_BREWING: 21,
  ACTION_MANUAL_SPARGE: 22,
  ACTION_REPLACE_MASH: 23,
  ACTION_PLACE_CARROUSEL: 24,
  ACTION_RESUME_BREWING: 25,
  ACTION_PREPARE_FERMENTATION: 26,
  ACTION_DO_NOT_MOVE_KEG: 27,
  ACTION_PLACE_AIRLOCK: 28,
  ACTION_REMOVE_AIRLOCK: 29,
  ACTION_PLACE_TRUB_CONTAINER: 30,
  ACTION_CONNECT_PRESSURIZER: 31,
  ACTION_START_CLEANING: 32,
  ACTION_PAIR_GRAVITY_SENSOR: 36,
  ACTION_FINISH_CLEANING: 37,
  ACTION_KEG_NEEDS_CLEANING: 38,
  ACTION_PLACE_BLOW_OFF: 53,
  ACTION_REMOVE_BLOW_OFF: 54,
  ACTION_PREPARE_ACID_CLEANING: 56,
  ACTION_CLEAN_CIP_FILTER: 57,
  ACTION_CHECK_ACID_CLEANING_FLOW: 58,
  ACTION_ACID_CLEAN_MINIBREW_FAILED: 59,
  ACTION_FINISH_ACID_CLEANING: 60,
  ACTION_NEEDS_ACID_CLEANING: 63,
};

const USER_ACTIONS = Object.entries(USER_ACTION_IDS).reduce(
  (acc, [key, val]) => {
    acc[val] = key;
    return acc;
  },
  {},
);

export default USER_ACTIONS;
